import { fullstoryEvent } from './fullstory-event';
import { IndexedFilters, IndexedNestedFilter } from '@/catalog/types/filters';
import { flatten } from 'lodash-es';

export async function fullstorySubmitFilterEvent(filters: IndexedFilters) {
  let processedMakeModels;
  try {
    if (filters.makes) {
      const typeCastMakes = filters.makes as IndexedNestedFilter;
      const makeModels = Object.keys(typeCastMakes).map((key) => {
        return typeCastMakes[key].map((model) => {
          return `${key} ${model}`;
        });
      });
      processedMakeModels = flatten(makeModels);
    }
  } catch {
    processedMakeModels = null;
  }

  fullstoryEvent('submit_filter', {
    body_type: Object.values(filters.body_type ?? []).map((v) => `${v}`),
    drivetrain: Object.values(filters.drivetrain ?? []).map((v) => `${v}`),
    make_model: processedMakeModels ?? [],
    vehicle_color: Object.values(filters.exterior_color ?? []).map((v) => `${v}`),
    vehicle_seats: Object.values(filters.seats ?? []).map((v) => Number(v)),
    vehicle_year: Object.values(filters.model_year ?? []).map((v) => Number(v)),
  });
}
